<template>
  <div>
    <v-subheader v-if="!!$slots.header" class="grey lighten-2">
      <slot name="header" />
    </v-subheader>
    <template v-for="(item, itemIndex) in items">
      <v-list-item :key="`item-${_uid}-${itemIndex}`"
                   @mouseover="hoverId = item.id"
                   @mouseleave="hoverId = null"
                   @click="model = item.id"
                   :class="{ 'grey darken-2 white--text': item.id === model }">
          <v-list-item-content>
            <v-list-item-title v-if="item[itemTitle] !== undefined" @click="model = item.id">
              <strong>{{ item[itemTitle] }}</strong>
            </v-list-item-title>
            <v-list-item-subtitle v-if="item[itemSubtitle] !== undefined"
                                   :class="{ 'white--text': item.id === model }">
              {{ item[itemSubtitle] }}
            </v-list-item-subtitle>
            <v-list-item-subtitle v-if="item[itemDescription] !== undefined"
                                   :class="{ 'white--text': item.id === model }">
              {{ item[itemDescription] }}
            </v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-action v-if="hasActionsSlot(item.id) && (hoverId === item.id || persistActions.indexOf(item.id) !== -1)">
            <slot :name="`actions-${item.id}`"/>
          </v-list-item-action>
      </v-list-item>
      <v-divider :key="`divider-${_uid}-${itemIndex}`"></v-divider>
    </template>
    <template v-if="items.length === 0">
    <v-list-item>
        <v-list-item-content>
        <v-list-item-title class="text-sm-center">
            <v-icon color="grey lighten-1">{{ emptyIcon }}</v-icon>
        </v-list-item-title>
        </v-list-item-content>
    </v-list-item>
    <v-divider></v-divider>
    </template>
  </div>
</template>

<script>
import ModelBinding from '@/mixins/ModelBinding'

export default {
  name: 'ListItems',
  mixins: [ ModelBinding ],
  props: {
    /**
     * Item to view in the list
     */
    items: [Array, Object],
    /**
     * Empty Icon to display when items count equals zero
     */
    emptyIcon: {
      type: String,
      default: 'layers_clear'
    },
    /**
     * Title property of provided items
     */
    itemTitle: {
      type: String,
      default: 'title'
    },
    /**
     * Subtitle property of provided items
     */
    itemSubtitle: {
      type: String,
      default: 'subtitle'
    },
    /**
     * Description property of provided items
     */
    itemDescription: {
      type: String,
      default: 'description'
    },
    /**
     * ID of specific items to persist their actions even they're not hovered
     */
    persistActions: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      /**
       * Hovered item id
       */
      hoverId: null
    }
  },
  methods: {
    /**
     * Check if actions slot exists for specific item
     *
     * @params {Integer} id
     *
     * @return {Boolean}
     */
    hasActionsSlot (id) {
      return !!this.$slots[`actions-${id}`]
    }
  }
}
</script>
